<!--
 * @Description:
 * @Author: wjx
 * @Github:
 * @LastEditors: wjx
 * @Date: 2019-03-15 10:35:09
 * @LastEditTime: 2019-05-29 12:53:25
 -->
<template>
  <el-dialog :visible="true" title="专区链接" lock-scroll @close='closeEvent' width='800' top='100'
    style="margin-top:5vh;height:800px;">
    <div>链接已生成：{{url}}</div>
    <canvas ref="canvas" id="canvas"></canvas>
    <img :src="dcwjUrlImg" v-show='dcwjUrlImg' class="canImg">
    <div style="margin-bottom:50px;">扫码访问</div>
    <!--分页-->
    <div style="display:flex;justify-content:center;align-items:center;">
      <el-button type='primary' style="height:40px;" @click="closeEvent">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {
    pageInation
  } from "@/Mixin/listMixin";
  import {
    initSearch
  } from "@/Mixin/initSearch";
  import {
    project
  } from "@/api/ajax";
  import QRCode from "qrcode";
  export default {
    components: {

    },
    mixins: [pageInation, initSearch],
    props: {
      url: {
        type: String,
        default: 'http://www.baidu.com'
      }
    },
    data() {
      return {
        // tableData: {},
        getList: project.projectList, // 获取列表的AJAX
        searchQuery: {
          type: 2,
          projectName: "",
          enterpriseId: ""
        },
        dcwjUrlImg:''
      }
    },
    computed: {},
    watch: {
        url:{
            immediate:true,
            handler(v){
                this.$nextTick(() => {
                    this.useqrcode();
                });
            }
        }
    },
    created() {

    },
    methods: {
      useqrcode() {
        let canvas = this.$refs.canvas;
        QRCode.toCanvas(canvas, this.url, error => {
          if (error) console.error(error);
          this.dcwjUrlImg = canvas.toDataURL("image/png", 1);
        });
      },
      closeEvent() {
        this.$parent.showLink = false
      },
      confirm(item) {
        this.$confirm('是否确认取票', '请确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          getTicket({
            id: item.id
          }).then(res => {
            if (res.status == 1) {
              this.$notify({
                title: '成功',
                message: '操作成功',
                type: 'success'
              });
              item.isWatch = 1
            }
          }).catch(err => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            });
          })
        })

      },


    }
  }

</script>
<style lang="scss" scoped>
  #canvas {
    display: none;
    width: 216px;
    height: 216px;
  }
  .canImg{
      width: 216px;
      height: 216px;
  }
  .confirnBtn {
    position: absolute;
    width: 100px;
    height: 50px;
    top: 50%;
    right: 1%;
    margin-left: -50px;
    margin-top: -25px;
    text-align: center;
    font-size: 16px;
  }

  .childRuleForm {
    width: 90%;
    margin-left: 4%;
    // border: 1px solid rgb(128,128,128);

  }

</style>
